import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header/header"
import Footer from "./footer/footer"
import "./layout.css"
import "bootstrap/dist/css/bootstrap.css"
import "./font-face.css"
import "simple-line-icons/css/simple-line-icons.css"
import "../components/styles.css"
import "../components/form/form.css"
import "../components/form/grey-form.css"
import "../components/form/Social-Icons.css"
import 'font-awesome/css/font-awesome.css'


const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <div style={{ overflow: "hidden" }}>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div>
        <main>{children}</main>
        <Footer />
      </div>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
